// extracted by mini-css-extract-plugin
export default {"block_body":"ManualModificationRulePane_block_body__OzvaQ","table_block":"ManualModificationRulePane_table_block__6zGOr","subheader":"ManualModificationRulePane_subheader__rV5Vp"};